<template>
    <div class="wenshidu-monitor-wrap">
        <div style="padding: 0 20px">
            <div class="title-wrap-energy">
                <span class="split-line-energy"></span>
                采集点选择
            </div>
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_id'"
                :showCheckbox="false"
                :cascadingVar="false"
                :checkStrictly="true"
                :isCheckClick="true"
                :defaultCheckKeys="defaultCheckKeys"
                :defaultExpandedKeys="defaultCheckKeys"
                @handleTreeNodeClick="handleTreeNodeClick"
                :showStretch="true"
            ></me-tree>
        </div>
        <div class="data-wrap">
            <div class="search-wrap">
                <el-form
                    :inline="true"
                    :model="searchForm"
                    class="leader-style-form leader-form-inner-tab-inline"
                >
                    <el-row :gutter="10">
                        <el-col :md="10" :xl="8">
                            <el-form-item label="开始时间" style="float: left">
                                <img
                                    @click="lastDayFrom"
                                    style="width: 25px;height: 25px;margin-right: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_left.png"
                                    alt
                                />
                                <el-date-picker
                                    v-model="searchForm.startTime"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :clearable="false"
                                    :editable="false"
                                ></el-date-picker>
                                <img
                                    @click="nextDayFrom"
                                    style="width: 25px;height: 25px;margin-left: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_right.png"
                                    alt
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :md="10" :xl="8">
                            <el-form-item label="结束时间">
                                <img
                                    @click="lastDayTo"
                                    style="width: 25px;height: 25px;margin-right: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_left.png"
                                    alt
                                />
                                <el-date-picker
                                    v-model="searchForm.endTime"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                    :clearable="false"
                                    :editable="false"
                                ></el-date-picker>
                                <img
                                    @click="nextDayTo"
                                    style="width: 25px;height: 25px;margin-left: 5px;cursor:pointer;"
                                    src="../../../../assets/image/custom/date_right.png"
                                    alt
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :md="4" :xl="8" style="text-align: right;">
                            <el-button type="primary" @click="search" size="small">查询</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="chart-data-wrap">
                <template v-if="this.state == 1">
                    <div style="text-align: center;line-height: 100%;height: 100%">
                        <img
                            style="margin-top: 10rem;"
                            src="../../../../assets/image/custom/no-collector.jpg"
                        />
                    </div>
                </template>
                <template v-else>
                    <div class="btn_cont">
                        <el-button class="btn_1" icon="el-icon-menu" @click="tableSwitch = true">图表</el-button>
                        <el-button class="btn_1" icon="el-icon-date" @click="tableSwitch = false">数据</el-button>
                        <!-- <download-excel
                            :data="json_data"
                            :fields="json_fields"
                            type="[csv,xls,xlsx]"
                            worksheet="sheet1"
                            :name="filename"
                            :before-generate="startDownload"
                            :before-finish="finishDownload"
                            style="display: inline-block; margin-left: 10px;"
                        >
                            <el-button
                                type="success"
                                class="btn_1"
                                icon="el-icon-download"
                                >导出</el-button
                            >
                        </download-excel>-->
                    </div>
                    <div class="chart-wrap">
                        <div class="echart-container" v-if="this.tableSwitch">
                            <v-chart :auto-resize="true" :options="line" ref="line" />
                        </div>
                        <div
                            class="table_container"
                            v-if="!this.tableSwitch"
                            style="height: 100% !important"
                        >
                            <el-scrollbar style="height: 100%">
                                <el-table
                                    class="leader-style-table"
                                    :data="tableData"
                                    border
                                    style="width: 100%"
                                >
                                    <template v-for="(item, index) in tableColumn">
                                        <el-table-column
                                            align="center"
                                            :prop="item.prop"
                                            :label="item.name"
                                            :key="index"
                                        ></el-table-column>
                                    </template>
                                </el-table>
                            </el-scrollbar>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import * as api from "@/http/api.js";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/dataZoom";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import dayjs from "dayjs";
export default {
    components: {
        "me-tree": Tree
    },
    data() {
        return {
            state: 1,
            treeData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "point_name"
            },
            defaultCheckKeys: [],
            searchForm: {
                startTime: "",
                endTime: ""
            },
            filename: "温湿度.xls",
            json_fields: {},
            json_data: [],
            loading: null,
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            sysDate: "",
            tableSwitch: true,
            legend: [],
            legendUnit: [],
            series: [],
            xAxis: [],
            tableColumn: [],
            tableData: [],
            current_point_id: "",
            currentNode: null
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        //获取采集点
        getPointList() {
            this.treeLoading = true;
            api.getUnitPointList({ point_class_id: '003' }).then(res => {
                if (res) {
                    this.treeLoading = false;
                    this.treeData = res.bus_json;
                    this.$refs.myTree.handleNodeClick(res.bus_json[0]);
                    this.defaultExpandedKeys = [res.bus_json[0].point_id];
                    // this.defaultCheckKeys = [res.bus_json[0].point_id];
                    this.current_point = res.bus_json[0];
                    this.current_point_id = res.bus_json[0].point_id;
                    this.state = res.bus_json[0].state;
                    this.getRealTimeDataOther();
                }
            });
        },
        handleTreeNodeClick(node) {
            // this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.current_point_id = node.point_id;
            this.state = node.state;
            this.currentNode = node;
            this.getRealTimeDataOther();
        },
        //获取系统时间
        getSysDate() {
            api.getSysDate1({}).then(res => {
                if (res) {
                    this.searchForm.startTime = res.bus_json.sysdate;
                    this.searchForm.endTime = res.bus_json.sysdate;
                    this.sysDate = res.bus_json.sysdate;
                    this.getPointList();
                }
            });
        },
        getRealTimeDataOther() {
            const diff = dayjs(this.searchForm.endTime).diff(dayjs(this.searchForm.startTime), 'day');
            if (diff > 2) {
                this.$message({
                    message: '时间查询范围不可大于3天',
                    type: "warning"
                });
                return;
            }
            // const loading = this.$loading({
            //     lock: true,
            //     text: "Loading",
            //     spinner: "el-icon-loading",
            //     background: "rgba(0, 0, 0, 0.7)"
            // });
            this.xAxis = [];
            this.legend = [];
            this.legendUnit = [];
            this.series = [];
            this.tableColumn = [{
                prop: 'time',
                name: '采集时间'
            }];
            this.tableData = [];
            this.json_fields = {
                采集点名称: "name",
                采集时间: {
                    field: "time",
                    callback: value => {
                        return value + "&nbsp;";
                    }
                },
            }
            this.json_data = [];
            api.getDataMonitor({
                ...this.searchForm,
                type: '温湿度',
                point_id: this.current_point_id
            }).then(res => {
                if (res && res.bus_json) {
                    this.xAxis = res.bus_json.upload_time;
                    const columnList = res.bus_json.columnList;
                    columnList && columnList.length && columnList[0].forEach(item => {
                        this.legend.push(item.column_desc);
                        this.legendUnit.push(item.column_unit);
                        this.tableColumn.push(
                            {
                                prop: item.column_name,
                                name: item.column_desc
                            }
                        );
                        this.json_fields[item.column_desc] = item.column_name;
                        this.series.push(
                            {
                                symbol: "none",
                                name: item.column_desc,
                                type: "line",
                                markPoint: {
                                    data: [
                                        { type: "max", name: "Max" },
                                        { type: "min", name: "Min" }
                                    ]
                                },
                                data: res.bus_json[item.column_name] ? res.bus_json[item.column_name] : []
                            }
                        );
                    })
                    this.xAxis && this.xAxis.length && this.xAxis.forEach((item, index) => {
                        const lineData = { 'time': item };
                        const json_data = {
                            name: this.currentNode ? this.currentNode.point_name : "",
                            time: item,
                        };
                        columnList && columnList.length && columnList[0].forEach(temp => {
                            lineData[temp.column_name] = res.bus_json[temp.column_name] ? res.bus_json[temp.column_name][index] : '',
                                json_data[temp.column_name] = res.bus_json[temp.column_name] ? res.bus_json[temp.column_name][index] : ''
                        })
                        this.tableData.push(lineData);
                        this.json_data.push(json_data);
                    })
                    if (!this.xAxis.length) {
                        this.json_data.push({
                            name: this.currentNode
                                ? this.currentNode.point_name
                                : "",
                            time: "",
                        });
                    }
                }
                // loading.close();
            });
        },
        //上一日
        lastDayFrom() {
            const now = dayjs(this.searchForm.startTime);
            this.searchForm.startTime = now.subtract(1, "days").format("YYYY-MM-DD");
            //this.search();
        },
        // 下一日
        nextDayFrom() {
            const now = dayjs(this.searchForm.startTime);
            this.searchForm.startTime = now.add(1, "days").format("YYYY-MM-DD");
            // this.search();
        },
        //上一日
        lastDayTo() {
            const now = dayjs(this.searchForm.endTime);
            this.searchForm.endTime = now.subtract(1, "days").format("YYYY-MM-DD");
            //   this.search();
        },
        // 下一日
        nextDayTo() {
            const now = dayjs(this.searchForm.endTime);
            this.searchForm.endTime = now.add(1, "days").format("YYYY-MM-DD");
            //  this.search();
        },
        search() {
            this.getRealTimeDataOther();
        },
        startDownload() {
            this.loading = this.$loading({
                lock: true,
                text: "下载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        finishDownload() {
            this.loading.close();
        }
    },
    computed: {
        line() {
            const legendUnit = this.legendUnit;
            const option = {
                title: {
                    text: "",
                    subtext: ""
                },
                tooltip: {
                    trigger: "axis",
                    formatter: function (params) {
                        var tar = params[0];
                        let formatter = tar.axisValue;
                        for (let i = 0; i < params.length; i++) {
                            formatter += "<br />" + params[i].marker + params[i].seriesName + "： " + params[i].data + legendUnit[i]
                        }
                        return formatter;
                    }
                },
                legend: {
                    data: this.legend,
                    textStyle: { fontSize: 12, color: "#fff" }
                },
                grid: {
                    left: "4%",
                    right: "1%",
                    bottom: "10%",
                    top: "10%",
                    containLabel: true
                },
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    },
                    data: this.xAxis
                },
                yAxis: {
                    type: "value",
                    name: "",
                    axisLabel: {
                        //x轴文字的配置
                        show: true,
                        textStyle: {
                            color: "#fff"
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                series: this.series
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.wenshidu-monitor-wrap {
    width: 100%;
    height: 93%;
    display: flex;
    flex-direction: row;
    .title-wrap-energy {
        text-align: left;
        font-size: 16px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        justify-content: left;
        border-bottom: 1px solid #dedede;
        margin-bottom: 10px;
        .title-energy {
            padding-right: 10px;
        }
        .split-line-energy {
            display: inline-block;
            background: #56fcff;
            width: 4px;
            height: 14px;
            border-radius: 2px;
            margin-right: 10px;
        }
    }
    .data-wrap {
        width: calc(100% - 300px);
        height: 100%;
        box-sizing: border-box;
        padding: 20px;
        .search-wrap {
            margin-top: 20px;
            margin-bottom: 30px;
            width: 100%;
            .time_btn {
                background: #29b85e;
                color: #fff;
            }
        }
        .chart-data-wrap {
            width: 100%;
            background: url("../../../../assets/image/custom/table-bg.png")
                no-repeat;
            background-size: 100% 100%;
            padding: 30px;
            box-sizing: border-box;
            height: 90%;
            .btn_cont {
                text-align: right;
                .btn_1 {
                    color: #56fbff;
                    text-align: center;
                    border-width: 1px;
                    border-color: #56fbff;
                    border-style: solid;
                    border-radius: 8px;
                    background-color: rgba(86, 251, 255, 0);
                    cursor: pointer;
                }
                .btn_3 {
                    color: #fff;
                }
            }
        }
        .chart-wrap {
            width: 100%;
            height: 90%;
            margin-top: 30px;
            .echart-container {
                width: 100%;
                height: 100%;
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>
